(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
document.addEventListener('DOMContentLoaded', function () {
  var toggles = document.querySelectorAll('.footer-accordion__toggle');
  if (!toggles.length) return;

  var mq = window.matchMedia('(max-width: 750px)');
  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function panelFor(btn) {
    var id = btn.getAttribute('aria-controls');
    return id ? document.getElementById(id) : null;
  }

  function openPanel(btn, panel) {
    btn.setAttribute('aria-expanded', 'true');
    if (reduceMotion) { panel.hidden = false; panel.style.height = 'auto'; panel.style.opacity = '1'; return; }

    panel.hidden = false;                     
    var h = panel.scrollHeight;              
    panel.style.height = '0px';
    panel.style.opacity = '0';
    requestAnimationFrame(function () {       
      panel.style.height = h + 'px';
      panel.style.opacity = '1';
    });
    panel.addEventListener('transitionend', function te(e) {
      if (e.propertyName === 'height') {
        panel.style.height = 'auto';          
        panel.removeEventListener('transitionend', te);
      }
    });
  }

  function closePanel(btn, panel) {
    btn.setAttribute('aria-expanded', 'false');
    if (reduceMotion) { panel.hidden = true; panel.style.height = ''; panel.style.opacity = ''; return; }

    var h = panel.scrollHeight;               
    panel.style.height = h + 'px';            
    panel.style.opacity = '1';
    requestAnimationFrame(function () {
      panel.style.height = '0px';
      panel.style.opacity = '0';
    });
    panel.addEventListener('transitionend', function te(e) {
      if (e.propertyName === 'height') {
        panel.hidden = true;                 
        panel.style.height = '';
        panel.removeEventListener('transitionend', te);
      }
    });
  }

  function setInitial() {
    toggles.forEach(function (btn) {
      var panel = panelFor(btn);
      if (!panel) return;

      if (mq.matches) {                      
        btn.setAttribute('aria-expanded', 'false');
        panel.hidden = true;
        panel.style.height = '0px';
        panel.style.opacity = '0';
      } else {                                
        btn.setAttribute('aria-expanded', 'true');
        panel.hidden = false;
        panel.style.height = 'auto';
        panel.style.opacity = '1';
      }
    });
  }

  setInitial();
  mq.addEventListener('change', setInitial);

  toggles.forEach(function (btn) {
    var panel = panelFor(btn);
    if (!panel) return;

    btn.addEventListener('click', function () {
      if (!mq.matches) return;                
      var open = btn.getAttribute('aria-expanded') === 'true';
      open ? closePanel(btn, panel) : openPanel(btn, panel);
    });
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }
    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};
      this.setHeaderHeight();
      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));
      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }
      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');
      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);
      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);
      this.createObserver();
    }
    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }
    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }
    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });
      observer.observe(this.header);
    }
    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;
      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);
          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);
          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }
      this.currentScrollTop = scrollTop;
    }
    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }
    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }
    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }
    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }
    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }
  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
